export default [
    {
        path: '/occurrenceTypes',
        name: 'occurrenceTypes',
        component: () => import ('./pages/Index')
    },
]